module.exports = __webpack_public_path__ + "9cf39bf2b912153669d6eb75ae4271d7.jpg";